export default __webpack_public_path__ + "static/media/flag-pitcairn-islands.7f377721.svg";